export default __webpack_public_path__ + "static/media/vicon-slogan.266f7750.png";